const configuredApiBaseUrl = String(
  import.meta.env.VITE_API_BASE_URL ?? (import.meta.env.MODE === 'native' ? 'https://mentor.report' : ''),
).trim().replace(/\/$/, '');

export function apiUrl(path: string): string {
  if (!configuredApiBaseUrl || !path.startsWith('/')) return path;
  return `${configuredApiBaseUrl}${path}`;
}

export function apiBaseUrl(): string {
  return configuredApiBaseUrl;
}
